const config = require('../core/config');
const { Keywords } = require('../core/keywords');
const Keyboard = require('simple-keyboard').default;
const KeyboardLayouts = require('simple-keyboard-layouts').default;
// const keyboardCss = require('simple-keyboard/build/css/index.css'); // handled by build.js

function initKeyboard(insertCallback, initialLanguage) {
    const keyboardPanel = document.querySelector('.keyboard-panel');
    const keyboardToggle = document.getElementById('keyboard-toggle');
    const keyboardContent = document.getElementById('keyboard-content'); // Custom keys

    let simpleKeyboard;
    let keyboardLayouts = new KeyboardLayouts();

    // Map language names to simple-keyboard layout names
    const layoutMap = {
        english: 'english',
        hindi: 'hindi',
        marathi: 'hindi', // Marathi uses Devanagari, same as Hindi
        bengali: 'bengali',
        german: 'german'
    };

    const fullKeyboardToggle = document.getElementById('full-keyboard-toggle');
    const simpleKeyboardEl = document.querySelector('.simple-keyboard');
    let isFullKeyboardShown = false;

    fullKeyboardToggle.addEventListener('click', (e) => {
        e.stopPropagation(); // Don't trigger the panel toggle
        isFullKeyboardShown = !isFullKeyboardShown;
        simpleKeyboardEl.classList.toggle('show', isFullKeyboardShown);
        fullKeyboardToggle.textContent = isFullKeyboardShown ? 'Hide Full Keyboard' : 'Show Full Keyboard';

        // Ensure the panel is open if we are showing the keyboard
        if (isFullKeyboardShown && !keyboardPanel.classList.contains('open')) {
            const appContainer = document.querySelector('.app-container');
            appContainer.classList.add('keyboard-open');
            keyboardPanel.classList.add('open');
        }
    });

    keyboardToggle.addEventListener('click', () => {
        const appContainer = document.querySelector('.app-container');
        appContainer.classList.toggle('keyboard-open');
        keyboardPanel.classList.toggle('open');
    });

    // Initialize Simple Keyboard
    simpleKeyboard = new Keyboard({
        onChange: input => onChange(input),
        onKeyPress: button => onKeyPress(button),
        layoutName: 'default'
    });

    function onChange(input) {
    }

    function onKeyPress(button) {
        if (button === "{shift}" || button === "{lock}") handleShift();
        else if (button === "{enter}") insertCallback('\n');
        else if (button === "{bksp}") { } // No-op for now
        else if (button === "{tab}") insertCallback('\t');
        else if (button === "{space}") insertCallback(' ');
        else insertCallback(button);
    }

    function handleShift() {
        const currentLayout = simpleKeyboard.options.layoutName;
        const shiftToggle = currentLayout === "default" ? "shift" : "default";

        simpleKeyboard.setOptions({
            layoutName: shiftToggle
        });
    }

    return function updateKeyboard(languageName, name, customKeywords) {
        // 1. Update Custom Helper Keys
        keyboardContent.innerHTML = '';

        const langConfig = config.getResolvedKeywords(languageName, name, customKeywords);

        // Show all keywords from the Keywords constant
        const keysToShow = Object.keys(Keywords);

        keysToShow.forEach(keywordId => {
            const word = langConfig[keywordId];
            if (word) {
                const btn = document.createElement('div');
                btn.className = 'key-btn';

                const label = document.createElement('span');
                label.className = 'key-label';
                label.textContent = word;

                const desc = document.createElement('span');
                desc.className = 'key-desc';
                desc.textContent = keywordId.replace(/_/g, ' ').toLowerCase();

                btn.appendChild(label);
                btn.appendChild(desc);

                btn.addEventListener('click', () => {
                    insertCallback(word + ' ');
                });

                keyboardContent.appendChild(btn);
            }
        });

        // 2. Update Full Layout
        const layoutName = layoutMap[languageName] || 'english';
        try {
            const layout = keyboardLayouts.get(layoutName);
            if (layout) {
                simpleKeyboard.setOptions(layout);
            } else {
                // Fallback to default (QWERTY) if layout not found
                simpleKeyboard.setOptions({
                    layout: {
                        default: [
                            "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
                            "{tab} q w e r t y u i o p [ ] \\",
                            "{lock} a s d f g h j k l ; ' {enter}",
                            "{shift} z x c v b n m , . / {shift}",
                            ".com @ {space}"
                        ],
                        shift: [
                            "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
                            "{tab} Q W E R T Y U I O P { } |",
                            "{lock} A S D F G H J K L : \" {enter}",
                            "{shift} Z X C V B N M < > ? {shift}",
                            ".com @ {space}"
                        ]
                    }
                });
            }
        } catch (e) {
            console.warn("Could not load layout for", layoutName, e);
        }
    };
}

module.exports = initKeyboard;
